import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { CouponService } from 'src/app/services/coupon.service';

// TODO: Replace this with your own data model type
export interface CoupontblItem {
  couponName: string;
  createdDate: string;
  jaldeeCouponCode: string;
  startDate: string;
  endDate: string;
  status: string;
  domain: string;

}

// TODO: replace this with real data from your application
// const EXAMPLE_DATA = [

//   {
//     'jaldeeCouponCode': 'OnamCoupon2018', 'couponName': 'Onam Coupon', 'couponDescription': 'Onam offer',
//     'consumerTermsAndconditions': 'consumer first use', 'providerDescription': '50% offer',
//     'couponRules': {
//       'discountType': 'AMOUNT', 'discountValue': '50',
//       'maxDiscountValue': '100', 'defaultEnabled': 'false', 'alwaysEnabled': 'false',
//       'maxReimbursePercentage': '100', 'minBillAmount': '1000', 'maxProviderUseLimit': '1000',
//       ' maxConsumerUseLimit': '5', 'maxConsumerUseLimitPerProvider': '2', 'firstCheckinOnly': true,
//       'firstCheckinPerProviderOnly': true, 'selfPaymentRequired': false, 'onlineCheckinRequired': true,
//       'combineWithOtherCoupon': false, 'ageGroup': 'CHILDREN', 'startDate': '01-11-2018', 'endDate': '31-12-2018'
//     },
//     'target': {
//       'domain': ['healthCare', 'personalCare'],
//       'subdomain': ['physiciansSurgeons', 'dentists', 'beautyCare', 'personalFitness'],
//       'couponLocation': [{ 'longitude': '89.524764', 'latitude': '88.259874', 'radius': '5' },
//       { 'longitude': '70.524764', 'latitude': '88.259874', 'radius': '2' }], 'licenseRequired': [5, 1]
//     }, 'createdDate': '01-11-2018', 'status': 'Draft'
//   },
//   {
//     'jaldeeCouponCode': 'MAx1002018', 'couponName': 'Diwali Coupon',
//     'couponDescription': 'Onam offer', 'consumerTermsAndconditions': 'consumer first use',
//     'providerDescription': '50% offer', 'couponRules': {
//       'discountType': 'AMOUNT', 'discountValue': '50',
//       'maxDiscountValue': '100', 'defaultEnabled': 'false', 'alwaysEnabled': 'false', 'maxReimbursePercentage': '100',
//       'minBillAmount': '1000', 'maxProviderUseLimit': '1000', 'maxConsumerUseLimit': '5',
//       'maxConsumerUseLimitPerProvider': '2', 'firstCheckinOnly': true, 'firstCheckinPerProviderOnly': true,
//       'selfPaymentRequired': false, 'onlineCheckinRequired': true, 'combineWithOtherCoupon': false,
//       'ageGroup': 'CHILDREN', 'startDate': '01/11/2018', 'endDate': '31/12/2018'
//     },
//     'target': {
//       'domain': ['healthCare', 'personalCare'], 'subdomain': ['physiciansSurgeons',
//         'dentists', 'beautyCare', 'personalFitness'],
//       'couponLocation': [{ 'longitude': '89.524764', 'latitude': '88.259874', 'radius': '5' },
//       { 'longitude': '70.524764', 'latitude': '88.259874', 'radius': '2' }], 'licenseRequired': [5, 1]
//     }, 'createdDate': '01-11-2018', 'status': 'Draft'
//   }

//   // { couponName: 'CouponMax', createdDate: '02-11-2018', jaldeeCouponCode: 'MAX100',
//   //  startDate: '02-11-2018',  endDate: '02-11-2018', status: 'Draft', domain: 'domain-healthCare' },
//   //  { couponName: 'CouponSummer', createdDate: '02-11-2018', jaldeeCouponCode: 'SUMMER100',
//   //  startDate: '02-11-2018',  endDate: '02-11-2018', status: 'Draft', domain: 'domain-personalCare' },
//   //  { couponName: 'CouponDiwali', createdDate: '02-11-2018', jaldeeCouponCode: 'DIWAL50',
//   //  startDate: '02-11-2018',  endDate: '02-11-2018', status: 'Live', domain: 'domain-healthCare' },
//   //  { couponName: 'Coupon100', createdDate: '02-11-2018', jaldeeCouponCode: 'MAX50',
//   //  startDate: '02-11-2018',  endDate: '02-11-2018', status: 'Expired', domain: 'domain-healthCare' },
//   //  { couponName: 'CouponMin', createdDate: '02-11-2018', jaldeeCouponCode: 'MIN100',
//   //  startDate: '02-11-2018',  endDate: '02-11-2018', status: 'Disabled', domain: 'domain-healthCare' },

// ];

/**
 * Data source for the Coupontbl view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class CoupontblDataSource extends DataSource<any> {

  private couponSubject = new BehaviorSubject<any>([]);

  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();


  constructor(private couponService: CouponService) {
    super();
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(collectionViewer: CollectionViewer): Observable<any> {

    return this.couponSubject.asObservable();

  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect(collectionViewer: CollectionViewer) {
    this.couponSubject.complete();
    this.loadingSubject.complete();
  }

  // private getPagedData(data: any) {
  //   const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
  //   return data.splice(startIndex, this.paginator.pageSize);
  // }
  loadCoupons(filter,
    sortDirection, count, pageSize) {
    this.loadingSubject.next(true);
    this.couponService.getCoupons(filter, sortDirection,
      count, pageSize).pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(coupons => {
        this.couponSubject.next(coupons);
      });
  }

}



/** Simple sort comparator for example ID/couponName columns (for client-side sorting). */
function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
